module.exports = __webpack_public_path__ + "static/media/notifications-icon.b6bda53c.svg";